// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenu-cls1_VwT","cls2":"AccountMenu-cls2_Hvm AccountMenu-cls1_VwT"};